var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPartnerWithUsHeaderBgM = function SvgPartnerWithUsHeaderBgM(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255,
    height: 235,
    viewBox: "0 0 255 235",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "86.841%",
    x2: "13.918%",
    y1: "55.059%",
    y2: "28.346%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M41.508 163.488c33.464 157.532 127.3 48.128 166.387 151.288 32.259 85.136 154.216 65.71 189.32-24.716 18.176-46.824 16.89-147.496-86.664-203.719C211.771 32.71 8.045 5.956 41.508 163.488z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "97.999%",
    x2: "15.668%",
    y1: "-8.471%",
    y2: "60.663%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "64.727%",
    x2: "64.727%",
    y1: "67.925%",
    y2: "135.857%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(-21 -203.808 559.378)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    transform: "rotate(16 221.968 206.926)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.182,
    cy: 245.886,
    fill: "url(#c)",
    mask: "url(#d)",
    rx: 115.755,
    ry: 121.541
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 444.053,
    cy: 239.632,
    fill: "url(#e)",
    mask: "url(#d)",
    rx: 87.632,
    ry: 108.473,
    transform: "rotate(99 444.053 239.632)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPartnerWithUsHeaderBgM);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/partner-with-us-header-bg-m.97b5a4611b7b7876c1eecb89c7e9f8ed.svg";